import _ from "lodash";

export default function checkIfAddressEmpty(address) {
  if (_.isEmpty(address) || _.isNil(address)) return true;
  const fieldsToCheck = [ "county", "flatNumber", "houseNumber", "postCode", "street", "town", "municipality" ];
  const hasEmptyFields = fieldsToCheck.some(item => !address[item]);
  return hasEmptyFields;
}
